import { useEffect, useState } from "react";

// Mobile vs. desktop split, matching Tailwind's `sm` breakpoint (640px) — the
// same line the rest of the app branches on via `sm:` utility classes.
const QUERY = "(min-width: 640px)";

/** True when the viewport is at/above the `sm` breakpoint. Reactive to resize. */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.matchMedia(QUERY).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsDesktop(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isDesktop;
}
